import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import RemoteTriggerService from 'services/RemoteTriggerService'

export const initialState = {
    sendMessage: {
        data: [],
        isLoading: false,
        error: false,
    },

    deleteTransactionalData: {
        data: [],
        isLoading: false,
        error: false,
    },

    unlockConnector: {
        data: [],
        isLoading: false,
        error: false,
    },

    resetConnector: {
        data: [],
        isLoading: false,
        error: false,
    },

    startTransaction: {
        data: [],
        isLoading: false,
        error: false,
    },

    stopTransaction: {
        data: [],
        isLoading: false,
        error: false,
    },

    updateFirmware: {
        data: [],
        isLoading: false,
        error: false,
    },

    updateFirmwareV2: {
        data: [],
        isLoading: false,
        error: false,
    },

    triggerMessageV2: {
        data: [],
        isLoading: false,
        error: false,
    },

    getDiagnostic: {
        data: [],
        isLoading: false,
        error: false,
    },

    sendCommand: {
        data: [],
        isLoading: false,
        error: false,
    },
}

export const sendMessage = createAsyncThunk('remoteTrigger/sendMessage', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.sendMessage(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const deleteTransactionalData = createAsyncThunk(
    'remoteTrigger/deleteTransactionalData',
    async (data, { rejectWithValue }) => {
        try {
            const response = await RemoteTriggerService.deleteTransactionalData(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const unlockConnector = createAsyncThunk('remoteTrigger/unlockConnector', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.unlockConnector(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const changeAvailabilityConnector = createAsyncThunk('remoteTrigger/changeAvailability', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.changeAvailability(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const sendDispenserActionConnector = createAsyncThunk('remoteTrigger/dispenserAction', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.sendDispenserAction(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const resetConnector = createAsyncThunk('remoteTrigger/resetConnector', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.resetConnector(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const startTransaction = createAsyncThunk(
    'remoteTrigger/startTransaction',
    async (data, { rejectWithValue }) => {
        try {
            const response = await RemoteTriggerService.startTransaction(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const stopTransaction = createAsyncThunk('remoteTrigger/stopTransaction', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.stopTransaction(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const updateFirmware = createAsyncThunk('remoteTrigger/updateFirmware', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.updateFirmware(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const updateFirmwareV2 = createAsyncThunk(
    'remoteTrigger/updateFirmwareV2',
    async (data, { rejectWithValue }) => {
        try {
            const response = await RemoteTriggerService.updateFirmwareV2(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const triggerMessageV2 = createAsyncThunk(
    'remoteTrigger/triggerMessageV2',
    async (data, { rejectWithValue }) => {
        try {
            const response = await RemoteTriggerService.triggerMessageV2(data)
            return response.data
        } catch (err) {
            return rejectWithValue(err.response?.data?.error || 'Error')
        }
    }
)

export const getDiagnostic = createAsyncThunk('remoteTrigger/getDiagnostic', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.getDiagnostic(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const sendCommand = createAsyncThunk('remoteTrigger/sendCommand', async (data, { rejectWithValue }) => {
    try {
        const response = await RemoteTriggerService.sendCommand(data)
        return response.data
    } catch (err) {
        return rejectWithValue(err.response?.data?.error || 'Error')
    }
})

export const remoteTriggerSlice = createSlice({
    name: 'remoteTrigger',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder

            .addCase(sendMessage.pending, (state, action) => {
                state.sendMessage.isLoading = true
            })
            .addCase(sendMessage.rejected, (state, action) => {
                state.sendMessage.isLoading = false
                state.sendMessage.error = true
            })
            .addCase(sendMessage.fulfilled, (state, action) => {
                state.sendMessage.isLoading = false
                state.sendMessage.error = false
                state.sendMessage.data = [...state.sendMessage.data, action.payload]
            })

            .addCase(deleteTransactionalData.pending, (state, action) => {
                state.deleteTransactionalData.isLoading = true
            })
            .addCase(deleteTransactionalData.rejected, (state, action) => {
                state.deleteTransactionalData.isLoading = false
                state.deleteTransactionalData.error = true
            })
            .addCase(deleteTransactionalData.fulfilled, (state, action) => {
                state.deleteTransactionalData.isLoading = false
                state.deleteTransactionalData.error = false
                state.deleteTransactionalData.data = [...state.deleteTransactionalData.data, action.payload]
            })

            .addCase(unlockConnector.pending, (state, action) => {
                state.unlockConnector.isLoading = true
            })
            .addCase(unlockConnector.rejected, (state, action) => {
                state.unlockConnector.isLoading = false
                state.unlockConnector.error = true
            })
            .addCase(unlockConnector.fulfilled, (state, action) => {
                state.unlockConnector.isLoading = false
                state.unlockConnector.error = false
                state.unlockConnector.data = [...state.unlockConnector.data, action.payload]
            })

            .addCase(resetConnector.pending, (state, action) => {
                state.resetConnector.isLoading = true
            })
            .addCase(resetConnector.rejected, (state, action) => {
                state.resetConnector.isLoading = false
                state.resetConnector.error = true
            })
            .addCase(resetConnector.fulfilled, (state, action) => {
                state.resetConnector.isLoading = false
                state.resetConnector.error = false
                state.resetConnector.data = [...state.resetConnector.data, action.payload]
            })

            .addCase(startTransaction.pending, (state, action) => {
                state.startTransaction.isLoading = true
            })
            .addCase(startTransaction.rejected, (state, action) => {
                state.startTransaction.isLoading = false
                state.startTransaction.error = true
            })
            .addCase(startTransaction.fulfilled, (state, action) => {
                state.startTransaction.isLoading = false
                state.startTransaction.error = false
                state.startTransaction.data = [...state.startTransaction.data, action.payload]
            })

            .addCase(stopTransaction.pending, (state, action) => {
                state.stopTransaction.isLoading = true
            })
            .addCase(stopTransaction.rejected, (state, action) => {
                state.stopTransaction.isLoading = false
                state.stopTransaction.error = true
            })
            .addCase(stopTransaction.fulfilled, (state, action) => {
                state.stopTransaction.isLoading = false
                state.stopTransaction.error = false
                state.stopTransaction.data = [...state.stopTransaction.data, action.payload]
            })

            .addCase(updateFirmware.pending, (state, action) => {
                state.updateFirmware.isLoading = true
            })
            .addCase(updateFirmware.rejected, (state, action) => {
                state.updateFirmware.isLoading = false
                state.updateFirmware.error = true
            })
            .addCase(updateFirmware.fulfilled, (state, action) => {
                state.updateFirmware.isLoading = false
                state.updateFirmware.error = false
                state.updateFirmware.data = [...state.updateFirmware.data, action.payload]
            })

            .addCase(updateFirmwareV2.pending, (state, action) => {
                state.updateFirmwareV2.isLoading = true
            })
            .addCase(updateFirmwareV2.rejected, (state, action) => {
                state.updateFirmwareV2.isLoading = false
                state.updateFirmwareV2.error = true
            })
            .addCase(updateFirmwareV2.fulfilled, (state, action) => {
                state.updateFirmwareV2.isLoading = false
                state.updateFirmwareV2.error = false
                state.updateFirmwareV2.data = [...state.updateFirmwareV2.data, action.payload]
            })

            .addCase(triggerMessageV2.pending, (state, action) => {
                state.triggerMessageV2.isLoading = true
            })
            .addCase(triggerMessageV2.rejected, (state, action) => {
                state.triggerMessageV2.isLoading = false
                state.triggerMessageV2.error = true
            })
            .addCase(triggerMessageV2.fulfilled, (state, action) => {
                state.triggerMessageV2.isLoading = false
                state.triggerMessageV2.error = false
                state.triggerMessageV2.data = [...state.triggerMessageV2.data, action.payload]
            })

            .addCase(getDiagnostic.pending, (state, action) => {
                state.getDiagnostic.isLoading = true
            })
            .addCase(getDiagnostic.rejected, (state, action) => {
                state.getDiagnostic.isLoading = false
                state.getDiagnostic.error = true
            })
            .addCase(getDiagnostic.fulfilled, (state, action) => {
                state.getDiagnostic.isLoading = false
                state.getDiagnostic.error = false
                state.getDiagnostic.data = [...state.getDiagnostic.data, action.payload]
            })

            .addCase(sendCommand.pending, (state, action) => {
                state.sendCommand.isLoading = true
            })
            .addCase(sendCommand.rejected, (state, action) => {
                state.sendCommand.isLoading = false
                state.sendCommand.error = true
            })
            .addCase(sendCommand.fulfilled, (state, action) => {
                state.sendCommand.isLoading = false
                state.sendCommand.error = false
                state.sendCommand.data = [...state.sendCommand.data, action.payload]
            })
    },
})

export default remoteTriggerSlice.reducer
